import React, { ChangeEventHandler, useRef } from 'react';
import { IconButton, TextField, Tooltip } from 'pvs-design-system';
import { ContentCopy } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import copyToClipboard from 'utils/copyToClipboard';

export const StyledTextField = styled(TextField)(({ theme }) => ({
  width: theme.spacing(60),
}));

export interface ICopyTextField {
  id: string;
  label: string;
  required: boolean;
  defaultValue: string | null;
  readonly: boolean;
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  helperText?: string | null;
  tooltipTitle?: string | null;
}

export const CopyTextField = ({
  id,
  label,
  required,
  defaultValue,
  readonly,
  onChange,
  helperText,
  tooltipTitle,
}: ICopyTextField) => {
  const textRef = useRef<HTMLInputElement | null>(null);

  return (
    <TextField
      InputProps={{
        endAdornment: (
          <Tooltip title={tooltipTitle || 'Copy Text'}>
            <IconButton
              id={`${label}copy`}
              aria-label={tooltipTitle || 'Copy Text'}
              color="primary"
              size="small"
              onClick={() => {
                const copiedValue: string = textRef.current?.value ?? '';
                copyToClipboard(copiedValue);
              }}
            >
              <ContentCopy />
            </IconButton>
          </Tooltip>
        ),
      }}
      inputRef={textRef}
      id={id}
      color="primary"
      label={label}
      value={defaultValue}
      required={required}
      readOnly={readonly}
      size="medium"
      margin="dense"
      onChange={onChange}
      helperText={helperText}
    />
  );
};

CopyTextField.defaultProps = {
  helperText: null,
  tooltipTitle: null,
};

export default CopyTextField;
